import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    public campusYear: number;

    public logoPatner: string = 'static/images/logos/logo-comillas-white.png';
    public logoFSS   : string = 'static/images/logos/logo_fss.png'

    public urlPartner: string = 'https://www.comillas.edu/icade';
    public urlFSS    : string = 'https://unmundosalvadorsoler.org'

    constructor() { }

    ngOnInit() {

        this.campusYear = (new Date()).getFullYear();

    }

}
